module.exports = __webpack_public_path__ + "static/img/douhao.6f0f1e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/douhao.png
// module id = 440
// module chunks = 169